import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Typography,
  Divider,
  ListItemButton,
  ListItemText,
  AvatarGroup,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RandomlyColoredAvatar from "../../Layout/RandomlyColoredAvatar";
import PrimaryButton from "../../shared/PrimaryButton";
import { useDispatch } from "react-redux";
import { GetSubscriberByGroup } from "../state/alertActions";
const styleInput = {
  borderRadius: "4px",
  marginBottom: "15px",
  "& .MuiInputBase-root": {
    height: "37px",
    backgroundColor: "#fff",
  },
  "& .MuiOutlinedInput": {
    height: "36px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #DBDEE6",
  },
};

const GroupsList = ({
  formik,
  Groups,
  setTouched,
  state,
  CurrentGroup,
  touched,
  setPendingCurrentLicense,
  setIsConfirmationModalOpen,
  setAddNew,
  addNew,
  error,
}) => {
  const [query, setquery] = useState("");
  const dispatch = useDispatch();
  const handleChange = (e) => {
    formik.handleChange(e);
    setTouched(true);
  };

  const handleListItemClick = (item) => {
    if (item.id !== CurrentGroup?.id) {
      if (!touched) {
        dispatch({ type: "ADD_GROUP", payload: item });
        dispatch(
          GetSubscriberByGroup(
            { pageNumber: 1, pageSize: 10, searchCriteria: item?.id },
            error
          )
        );
        setAddNew(false);
      } else {
        setIsConfirmationModalOpen(true);
        setPendingCurrentLicense(item);
      }
    }
  };
  const inputRef = useRef();
  const showAddInput = () => {
    /*   if (touched) {
      setIsConfirmationModalOpen(true);
      return;
    } */
    if (addNew) return;
    setAddNew(true);
    dispatch({ type: "ADD_GROUP", payload: "" });
  };

  useEffect(() => {
    if (addNew) {
      inputRef.current.focus();
    }
  }, [addNew]);

  const HandleFillter = (e) => {
    setquery(e.target.value);
    dispatch({ type: "FilterLIST", payload: e.target.value });
    filteritems(state);
  };

  const filteritems = (state) => {
    const { AllGroups, searchtext } = state;
    let test = AllGroups.filter((item) => {
      return item.name.toLowerCase().indexOf(searchtext.toLowerCase()) !== -1;
    });
    console.log(test);
  };

  return (
    <>
      <Grid sx={{ padding: "15px" }}>
        <OutlinedInput
          type="text"
          size="small"
          fullWidth
          placeholder="Search Groups"
          onChange={(e) => HandleFillter(e)}
          endAdornment={
            <InputAdornment position="end">
              <IconButton aria-label="search" edge="end">
                <SearchIcon fontSize="small" color="#8792AB" />
              </IconButton>
            </InputAdornment>
          }
        />
      </Grid>
      <Grid
        container
        justifyContent="space-between"
        padding="15px"
        alignItems="baseline"
      >
        <Grid item>
          <Typography color="#50566E" fontSize={14}>
            {
              Groups.filter((item) => {
                return (
                  item.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
                );
              }).length
            }{" "}
            Groups
          </Typography>
        </Grid>
        <Grid item>
          <PrimaryButton onClick={() => showAddInput()}>
            New Group
          </PrimaryButton>
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: "10px" }} />
      <Grid>
        {addNew && (
          <>
            <ListItemButton
              sx={{
                padding: "20px",
                width: "100%",

                "&:hover": { backgroundColor: "#fff" },
                "&.Mui-selected": {
                  backgroundColor: "#fff !important",
                  borderLeft: "3px solid #1492AF",
                },
              }}
              selected={true}
            >
              <Grid container justifyContent="space-between">
                <Grid item>
                  <TextField
                    type="text"
                    placeholder="Add new Group"
                    inputRef={inputRef}
                    sx={styleInput}
                    name="name"
                    value={formik.values.name}
                    onChange={handleChange}
                    error={Boolean(formik.errors.name)}
                    helperText={formik.errors.name}
                  />
                </Grid>
              </Grid>
            </ListItemButton>
            <Divider />
          </>
        )}
        {React.Children.toArray(
          Groups.filter((item) => {
            return item.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
          }).map((group) => (
            <>
              <ListItemButton
                sx={{
                  padding: "20px",
                  width: "100%",
                  "&:hover": { backgroundColor: "#fff" },
                  "&.Mui-selected": {
                    backgroundColor: "#fff !important",
                    borderLeft: "3px solid #1492AF",
                  },
                }}
                onClick={() => handleListItemClick(group)}
                selected={CurrentGroup?.id === group?.id ? true : false}
              >
                <Grid container justifyContent="space-between">
                  <Grid item>
                    <ListItemText
                      sx={{
                        color: "#050D2E",
                        "& .MuiTypography-root": {
                          fontWeight: "bold",
                          fontSize: ".899rem",
                        },
                        marginLeft: "5px",
                        marginBottom: 2,
                      }}
                      primary={group.name}
                    />
                    {/*   <Typography fontSize="12px" marginBottom={2} color="#8792AB">Updated: Jan 12, 2020</Typography>
                     */}{" "}
                    <AvatarGroup
                      sx={{
                        justifyContent: "flex-end",
                        ".MuiAvatarGroup-avatar": {
                          width: "25px",
                          height: "25px",
                          fontSize: `${0.03 * 25}rem`,
                        },
                      }}
                      max={4}
                    >
                      {group?.customers?.length > 0 &&
                        React.Children.toArray(
                          group?.customers.map((sub) => (
                            <RandomlyColoredAvatar name={sub.name} size={25} />
                          ))
                        )}
                    </AvatarGroup>
                  </Grid>

                  <Grid item></Grid>
                </Grid>
              </ListItemButton>
              <Divider />
            </>
          ))
        )}
      </Grid>
    </>
  );
};

export default GroupsList;
